export default __webpack_public_path__ + "static/media/twitter.d806e5a3.svg";